import { QRCodeSVG } from "qrcode.react";
import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { useCartActions } from "../../contexts/CartServiceContext/CartServiceContext";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { PATH } from "../../router/path";
import {
	addDatadogAction,
	buildLocationContext,
	startNewDatadogSession,
} from "../../services/datadog";
import "./CashQRPage.scss";

interface ICashQRLocationState {
	qrContent: string;
}

const CashQRPage: React.FC = () => {
	const navigate = useNavigate();
	const routerLocation = useLocation();
	const { t } = useTranslation();
	const { state: configLocation } = useConfigContext((s) => s.location);
	const { state: stall } = useConfigContext((s) => s.config.stall);
	const { CLEAN_CART } = useCartActions();

	const state = routerLocation.state as ICashQRLocationState | null;
	const qrContent = state?.qrContent;

	useEffect(() => {
		addDatadogAction("cashqr_page_mount", {
			...buildLocationContext(configLocation, stall),
			hasQrContent: !!qrContent,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!qrContent) {
			addDatadogAction("cashqr_invalid_state_redirect", {
				...buildLocationContext(configLocation, stall),
			});
			navigate(PATH.LANDING, { replace: true });
		}
	}, [qrContent, navigate, configLocation, stall]);

	const handleCreateNew = useCallback(() => {
		addDatadogAction("cashqr_create_new_order", {
			...buildLocationContext(configLocation, stall),
		});
		startNewDatadogSession();
		CLEAN_CART();
		navigate(PATH.LANDING, { replace: true });
	}, [CLEAN_CART, navigate, configLocation, stall]);

	if (!qrContent) return null;

	return (
		<div className="CashQRPage">
			<div className="CashQRContent">
				<h1 className="CashQRTitle">{t("cashQR.bringToCashier")}</h1>
				<div className="CashQRCode">
					<QRCodeSVG value={qrContent} size={280} level="M" />
				</div>
				<button className="CashQRNewOrderButton" onClick={handleCreateNew}>
					{t("cashQR.createNewOrder")}
				</button>
			</div>
		</div>
	);
};

export default CashQRPage;
